import { Routes } from '@angular/router';
import { authGuard, guestGuard } from '@movilidad/app-core';

import { environment } from '../environments/environment';

/**
 * Las pantallas viven en `libs/app/feature-*`; aquí sólo se componen, con sus guards. Viajes, Boletos y
 * Perfil son la barra inferior de Home, la que manda en el diseño. Perfil aún es un hueco.
 */
export const routes: Routes = [
  { path: '', redirectTo: 'tabs/viajes', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [guestGuard],
    data: { brand: 'Passenger' },
    loadComponent: () => import('@movilidad/app-feature-auth').then((m) => m.LoginPage),
  },
  {
    path: 'recuperar',
    canActivate: [guestGuard],
    loadComponent: () => import('@movilidad/app-feature-auth').then((m) => m.ForgotPasswordPage),
  },
  {
    path: 'tabs',
    canActivate: [authGuard],
    loadComponent: () => import('./tabs/tabs.page').then((m) => m.TabsPage),
    children: [
      { path: '', redirectTo: 'viajes', pathMatch: 'full' },
      {
        path: 'viajes',
        data: { brand: 'Passenger' },
        loadComponent: () => import('@movilidad/app-feature-home').then((m) => m.HomePage),
      },
      {
        path: 'boletos',
        loadComponent: () => import('@movilidad/app-feature-tickets').then((m) => m.TicketsPage),
      },
      {
        path: 'perfil',
        data: { title: 'Perfil', canSignOut: true },
        loadComponent: () => import('./placeholder/placeholder.page').then((m) => m.PlaceholderPage),
      },
    ],
  },
  {
    // Fuera de las pestañas: el boleto ocupa toda la pantalla, sin barra inferior.
    path: 'boleto/:id',
    canActivate: [authGuard],
    loadComponent: () => import('@movilidad/app-feature-tickets').then((m) => m.TicketDetailPage),
  },
  {
    path: 'galeria',
    canMatch: [() => environment.gallery],
    loadComponent: () => import('@movilidad/app-feature-gallery').then((m) => m.GalleryPage),
  },
  { path: '**', redirectTo: '' },
];
